import { Flex } from 'antd';
import { Suspense } from 'react';

import { Loader } from '@/shared/ui';

export const SuspenseWithLoader: React.FC<React.PropsWithChildren> = ({ children }) => (
  <Suspense
    fallback={
      <Flex style={{ minHeight: '600px', position: 'relative', backgroundColor: 'white' }}>
        <Loader centered />
      </Flex>
    }
  >
    {children}
  </Suspense>
);
